// All functions here accept a callback. The callback will more than likely
// end up being a setState call in the component it is called from.

import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

/*
@returns array of MessageThreadHeader objects
[
  {
    count:3,
    id:403,
    preview:"again",
    read:true,
    subject:"test new message",
    time:1491852479323,
  },
];
*/
const getAllMessages = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/messages/all',
    headers,
    successCallback,
    errorCallback,
  );
};

/*
@JsonProperty("id")
private final long portalFolderId;
@JsonProperty("read")
private final boolean read;
@JsonProperty("contentFound")
private final boolean contentFound;
@JsonProperty("subject")
private final String subject;
@JsonProperty("items")
private final List<MessageThreadItem> items;
@JsonProperty("attachments")
private final List<MessageThreadAttachment> attachments;
*/
const getMessage = (threadId, successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    `/api/messages/${threadId}`,
    headers,
    successCallback,
    errorCallback,
  );
};

/*
@JsonProperty("subject") final String subject,
@JsonProperty("message") final String message,
@JsonProperty("recipients") final List<Long> recipients,
@JsonProperty("location") final Long locationId,
@JsonProperty("healthInfoInMessage") final boolean sendHealthInfo

We do not pass the additional headers as the send is a blob

*/
const sendMessage = (body, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/messages/send',
    {},
    body,
    successCallback,
    errorCallback,
  );
};

const replyMessage = (body, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/messages/reply',
    headers,
    body,
    successCallback,
    errorCallback,
  );
};

// @GET
// @Path("possible-recipients")
const getPossibleRecipients = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/messages/possible-recipients',
    headers,
    successCallback,
    errorCallback,
  );
};

/*
@JsonProperty("id") final Long portalFolderId,
@JsonProperty("to") final String directAddress,
@JsonProperty("subject") final String subject,
@JsonProperty("message") final String message)
*/
const forwardMessage = (body, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/messages/forward',
    headers,
    body,
    successCallback,
    errorCallback,
  );
};

// POR-615 - deletes require an empty body {}, and in the case of IE throws an "unsupported BodyInit type" error, hence the JSON.stringify().
// Yes, we can write up a deleteMessageWithNoParam call, but as it is, this is one liner that we never need to come back and look at.
const deleteMessage = (messageId, successCallback, errorCallback) => {
  return UpdoxApi.deleteApi(
    `/api/messages/delete/${messageId}`,
    headers,
    JSON.stringify({}),
    successCallback,
    errorCallback,
  );
};

const MessagesApi = {
  forwardMessage,
  getAllMessages,
  getMessage,
  getPossibleRecipients,
  replyMessage,
  sendMessage,
  deleteMessage,
};

export default MessagesApi;



// WEBPACK FOOTER //
// ./src/apis/messages.js